import {
  TaxonomyOrganization,
} from '../implementations';

const mappers = {
  organization: TaxonomyOrganization,
};

export default mappers;
